import { useEffect } from 'react';

const addBodyClass = className => document.body.classList.add(className);
const removeBodyClass = className => document.body.classList.remove(className);

export default function useBodyClass(className) {
	useEffect(() => {
	
		if (Array.isArray(className)) {
			className.forEach(addBodyClass);
		} else {
			addBodyClass(className);
		}

		return () => {
			if (Array.isArray(className)) {
				className.forEach(removeBodyClass);
			} else {
				removeBodyClass(className);
			}
		};
	}, [className]);
}
